import { snapdom } from "@zumer/snapdom";
import type { OrderVo } from "@zhihaoscm/entity";
import { useMemo, useRef } from "react";
import { QrCode } from "@/components/media/QrCode";

/** Vue qrDialog 的 React 对应物，保留助力参数、下载版式和关闭刷新合同。 */
export function OrderInviteHelpDialog({ assistedId, detail, onClose, open }: { assistedId?: number; detail: OrderVo; onClose: () => void; open: boolean }) {
    const downloadRef = useRef<HTMLDivElement>(null);
    const product = detail.order.productInfo;
    const qrValue = useMemo(() => {
        const url = new URL("/help", window.location.origin);
        url.searchParams.set("prodId", String(detail.order.productId || ""));
        url.searchParams.set("prodTypeId", String(product?.productTypeId || ""));
        url.searchParams.set("beAssistedId", String(assistedId || ""));
        url.searchParams.set("bizType", "barginHelp");
        return url.toString();
    }, [assistedId, detail.order.productId, product?.productTypeId]);

    /** 下载内容沿用 Vue 隐藏海报节点，不能只导出裸二维码。 */
    const download = async () => {
        if (!downloadRef.current) return;
        const result = await snapdom(downloadRef.current);
        await result.download({ format: "png", filename: `${product?.title || "商品"}捡漏助力二维码` });
    };

    if (!open) return null;
    return (
        <div aria-label="邀请助力" aria-modal="true" className="order-invite-mask" onMouseDown={event => { if (event.currentTarget === event.target) onClose(); }} role="dialog">
            <div className="order-invite-modal">
                <header className="order-invite-header">
                    <h2>邀请助力</h2>
                    <button aria-label="关闭邀请助力" className="order-invite-close" onClick={onClose} type="button"><i className="iconfont icon-close1" /></button>
                </header>
                <p className="order-invite-tip">邀请好友使用链云砂石小程序或APP扫描以下二维码参与助力</p>
                <div className="order-invite-qr"><QrCode size={200} value={qrValue} /><button className="order-invite-download" onClick={() => void download()} type="button">下载二维码</button></div>
            </div>
            <div aria-hidden="true" className="order-invite-download-poster" ref={downloadRef}>
                <div className="order-invite-modal">
                    <header className="order-invite-header order-invite-header--download"><h2>捡漏助力二维码</h2></header>
                    <div className="order-invite-qr"><QrCode size={200} value={qrValue} /><div className="order-invite-brand"><img alt="" src="https://static.zhihaoscm.cn/logo/shaheshang-logo.png" /><span>请使用链云砂石小程序或APP扫一扫</span></div></div>
                </div>
            </div>
        </div>
    );
}
